import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    id: "manifesto-chapter-1",
    num: "01",
    title: "Capacity is the asset",
    body: "Your team's hours are the product. Every hour spent chasing a status update or re-typing a number is an hour a client will never pay for. We treat reclaimed time as the only metric that matters.",
  },
  {
    id: "manifesto-chapter-2",
    num: "02",
    title: "One source of truth",
    body: "When sales, projects, and the books each keep their own version of reality, someone has to reconcile them by hand. We connect them into a single secure record, so the answer is the same no matter who asks.",
  },
  {
    id: "manifesto-chapter-3",
    num: "03",
    title: "Right person, right information",
    body: "The foreman doesn't need the forecast. The owner doesn't need the punch list. Each person sees exactly what their role requires — nothing chased, nothing withheld, nothing extra.",
  },
  {
    id: "manifesto-chapter-4",
    num: "04",
    title: "Quiet technology",
    body: "The best tools disappear. Ours work inside the systems you already run, reading, writing, and acting in the background — so the experience is simply that work got easier.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="py-20 lg:py-32 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <Reveal className="mb-16 lg:mb-24">
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-brand-teal font-semibold mb-4">
            The Ocean Data manifesto
          </p>
          <h2 className="font-display font-semibold tracking-tight leading-[1.12] text-brand-navy text-2xl sm:text-3xl lg:text-4xl max-w-2xl">
            What we believe about work, in four chapters.
          </h2>
        </Reveal>

        <div>
          {CHAPTERS.map((ch, i) => (
            <Reveal key={ch.id} delay={0.05}>
              <div
                data-testid={ch.id}
                className="grid grid-cols-12 gap-6 lg:gap-12 py-12 lg:py-16 border-t border-slate-200 last:border-b"
              >
                <div className="col-span-3 lg:col-span-2">
                  <span className="od-outline-num font-display font-bold text-6xl sm:text-7xl lg:text-8xl leading-none select-none">
                    {ch.num}
                  </span>
                </div>
                <div className="col-span-9 lg:col-span-4">
                  <h3 className="font-display font-medium text-xl sm:text-2xl text-brand-navy leading-snug">
                    {ch.title}
                  </h3>
                </div>
                <div className="col-span-12 lg:col-span-5 lg:col-start-8">
                  <p className="text-base text-slate-600 leading-relaxed">{ch.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
